<!-- /系统管理/banner  -->
<template>
  <div style="display: flex; justify-content:flex-start ;padding: 30px">
    <div style="width:430px">
      <span >当前banner：</span>
      <div style="margin-top:20px">
        <div
          style="
            width: 400px;
            height: 100px;
            margin-bottom: 10px;
            display: flex;
          "
          v-for="(item, index) in imgUrlArray"
          :key="index"
        >
          <img style="width: 100%; height: 100%" :src="item" alt="" />
          <div>
               <i
              v-if="isShow"
              @click="delete1(index)"
              style="cursor: pointer"
              class="el-icon-circle-close"
            ></i>
            <i
              v-if="isShow"
              class="el-icon-top"
              style="cursor: pointer;margin-top:20px"
              @click="sort(index)"
            ></i>

          </div>

          <!-- {{item}} -->
        </div>
        <div style="margin-bottom: 30px">
          <el-button type="success" @click="edit">编辑</el-button>
        </div>
      </div>
    </div>
    <div>
      <span>修改banner:</span>
      <div style="margin-top:20px">
        <upload
          @imgUrlEmit="imgUrlEmit"
          :imgUrlArray="imgUrlArray"
          :num="5"
        ></upload>
        <div style="margin-top: 30px">
          <el-button type="success" @click="save()">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ConfigLoginList,
  ConfigLoginAdd,
  ConfigLoginEdit,
} from "../../../assets/js/network/network";
import upload from "../../../components/upload/upload";
export default {
  name: "configBanner",
  components: {
    upload,
  },
  props: {
    disposeData: Object,
    num: Number,
    fzzsjx: String,
    fzsjjx: String,
  },
  data() {
    return {
      imgUrlArray: [],
      isShow: false,
      data: {},
      dataList: [],
      url: "",
    };
  },
  mounted() {
    console.log(this.num, this.fzzsjx, this.fzsjjx);
    this.getBanner(); //获取banner
  },
  methods: {
    getBanner() {
      ConfigLoginList(this.disposeData).then((res) => {
        if (res.code == 0) {
          this.data = res.ret;
          if (this.data) {
            if (this.fzzsjx) {
              this.dataList = res.ret.login_after_vice_banner
                ? res.ret.login_after_vice_banner.split(",")
                : []; //仿真知识教学
            } else if (this.fzsjjx) {
              this.dataList = res.ret.login_practice_banner
                ? res.ret.login_practice_banner.split(",")
                : []; //仿真实践教学
            } else {
              this.dataList = res.ret.login_after_banner
                ? res.ret.login_after_banner.split(",")
                : []; //首页
            }
          }

          this.imgUrlArray = this.dataList;
        }
        // console.log(this.dataList);
      });
    },
    // 点击编辑
    edit() {
      this.isShow = true;
    },
    // 保存
    save() {
      ConfigLoginList(this.disposeData).then((res1) => {
        if(res1.code == 0){
          this.data = res1.ret
          if (!!this.data && !!this.data.id) {
            //修改
            let params = {
              id: this.data.id,
            };
            if (this.fzzsjx) {
              params.login_after_vice_banner = this.dataList.join(","); //仿真知识教学
            } else if (this.fzsjjx) {
              params.login_practice_banner = this.dataList.join(","); //仿真实践教学
            } else {
              params.login_after_banner = this.dataList.join(","); //首页
            }

            ConfigLoginEdit(params).then((res) => {
              if (res.code == 0) {
                this.$message.success("修改成功");
                this.getBanner(); //获取banner
              }
            });
          } else {
            //添加
            if (this.fzzsjx) {
              this.disposeData.login_after_vice_banner = this.dataList.join(","); //仿真知识教学
            } else if (this.fzsjjx) {
              this.disposeData.login_practice_banner = this.dataList.join(","); //仿真实践教学
            } else {
              this.disposeData.login_after_banner = this.dataList.join(","); //首页
            }

            ConfigLoginAdd(this.disposeData).then((res) => {
              if (res.code == 0) {
                this.$message.success("成功");
                this.getBanner(); //获取banner
              }
            });
          }
        }
      })

    },
    // 获取图片url
    imgUrlEmit(url) {
      //   console.log(url);
      this.dataList = [];
      if (url.length > 0) {
        url.map((item) => {
          this.dataList.push(item.url);
        });
      } else {
      }

      //   this.url = url;
      //   this.dataList.push(url)
      //   this.imgUrlArray.push(url)
      //   console.log(1111111,this.dataList)
    },
    delete1(index) {
      this.dataList.splice(index, 1);
      this.save();
    },
    // 向前移动
    sort(index) {
      console.log(index);
      if (index != 0) {
        this.imgUrlArray.splice(index - 1, 0, this.dataList[index]);
        this.imgUrlArray.splice(index + 1, 1);
      } else {
        this.imgUrlArray.push(this.imgUrlArray[index]);
        this.imgUrlArray.splice(index, 1);
      }
      this.dataList = this.imgUrlArray;
      this.save();
    },
  },
};
</script>

<style scoped>
img {
  object-fit: contain;
}
</style>
